class DownloadButton {
    constructor() {
        document.querySelectorAll(".downloadable-button a").forEach(el => {
            this.init(el)
        })
    }

    init(el) {
        console.log(el);
        el.addEventListener('click', (event) => {
            event.preventDefault();
            let href = el.getAttribute('href');
            this.downloadFile(href);
        });
    }

    downloadFile(url) {
        if (!url) {
            return;
        }

        fetch(url, {method: 'get', mode: 'no-cors', referrerPolicy: 'no-referrer'})
            .then(res => res.blob())
            .then(res => {
                const fileName = url.split('/').pop()
                const aElement = document.createElement('a');
                aElement.setAttribute('download', fileName);
                const href = URL.createObjectURL(res);
                aElement.href = href;
                aElement.setAttribute('target', '_blank');
                aElement.click();
                URL.revokeObjectURL(href);
            });
    };
}

export default DownloadButton
